function closeDropdown(exclude) {

    var element;

    // loop through all the .donors-wrapper menus
    if ($('.donors-wrapper .dropdown-wrapper.opened').length) {
        $('.donors-wrapper .dropdown-wrapper.opened').each(function () {
            element = $(this);
            if (exclude !== element.attr('data-dropdown')) {
                element.removeClass('opened');
            }
        });
    }

    // menus
    if ($('.menu-wrapper.opened').length) {
        $('.menu-wrapper.opened').each(function () {
            element = $(this);
            if (exclude !== element.attr('data-dropdown')) {
                element.removeClass('opened');
            }
        });
    }

    // loop through all the alumni menus
    if ($('.dropdown-wrapper.opened').length) {
        $('.dropdown-wrapper.opened').each(function () {
            element = $(this);
            if (exclude !== element.attr('data-dropdown')) {
                element.removeClass('opened');
            }
        });
    }
}

$('body').on('click', function(e) {
    // console.log(e);
    // console.log($(e.target).attr('data-dropdown'));

    if ($(e.target).is('a') || $(e.target).parents('a').length) {
        return;
    }

    if ($(e.target).is('input') || $(e.target).parents('input').length) {
        return;
    }

    if ($(e.target).is('label') || $(e.target).parents('label').length) {
        return;
    }

    console.log($(e.target));

    e.stopPropagation();
    closeDropdown($(e.target).attr('data-dropdown'));
});